import linq from 'linq'

export default {
    data() {
        return {
            items: [],
            totalPrice: 0,
            loading: true,
        }
    },

    created() {},

    mounted() {
        if (location.pathname !== '/cart') return
        this.getCartItems()
    },

    methods: {
        async getCartItems() {
            this.loading = true
            const { data } = await axios.get('/api/cart/get')
            this.setImage(data)
            this.items = data
            this.setTotalPrice()
            this.loading = false
        },

        setImage(data) {
            linq.from(data).forEach((x) => {
                if (x.image) {
                    x.item.product.img_path = x.image
                }
            })
        },

        setTotalPrice() {
            let price = 0
            linq.from(this.items)
                .select((x) => x.item.price_jpy * x.count)
                .select((x) => (price += x))
                .toArray()
            this.totalPrice = price
        },

        async deleteCart(index) {
            this.loading = true
            await axios.delete('/api/cart/delete/' + index)
            this.getCartItems()
        },

        async updateCart(index, item) {
            this.loading = true
            if (item.count < 1) {
                await this.deleteCart(index)
            } else {
                await axios.post('/api/cart/update', {
                    index: index,
                    count: item.count,
                })
                this.getCartItems()
            }
        },

        calcPriceWithTax() {
            const price = this.totalPrice * Laravel.config.app.tax
            return Number(Math.round(price)).toLocaleString()
        },

        async goCheckout() {
            await axios.post('/api/cart/update-all', {
                items: this.items,
            })
            this.getCartItems()
            window.location.href = '/checkout'
        },
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixin/cart.js